import { GDTMessageDirection } from '@lmt/shared-types';

export interface GDTMessageInfo {
  id: number;
  direction: GDTMessageDirection;
  content: string;
}

export function getFileName(message: GDTMessageInfo) {
  return `patient_${
    message.direction === GDTMessageDirection.Incoming ? 'incoming' : 'outgoing'
  }_message_${message.id}.gdt`;
}
